import { useEffect, useState } from "react";
import loginImage01 from "../../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../../assets/images/registration/registration-steps-image-04.jpg";
import { languages, raceEthnicities, countries } from "../../../Common/MasterData";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

import { updateUserData } from '../../../Redux/userReducer';
import { Endpoints } from "../../../Global/Endpoints";
import CustomDropdown from "../../../CustomControls/dropdown";


const UpdateAddress = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const contract = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    dateOfBirth: "",
    phoneNumber: "",
    agreeToTexts: false,
    country: "",
    state: "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    language: "",
    raceEthnicity: "",
    preferredName: "",
    gender: "",
    relationshipStatus: "",
    pronouns: "",
    goal: "",
    FirstName: "",
  });

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (contract.userData) {
      const languageValue = languages.find(lang =>
      lang.label === contract.userData.Language || lang.value === contract.userData.Language
    )?.label || "";
      const ethnicityValue = raceEthnicities.find(race => 
        race.label === contract.userData.Ethnicity || race.value === contract.userData.Ethnicity
      )?.value || "";

      setFormData({
        FirstName: contract.userData.FirstName || "",
        dateOfBirth: contract.userData.DOB || "",
        phoneNumber: contract.userData.MobileNumber || contract.userData.PhoneNo,
        agreeToTexts: contract.userData.TextNotificationStatus === "Yes",
        country: contract.userData.Country || "",
        state: contract.userData.State || "",
        city: contract.userData.City || "",
        address1: contract.userData.Address1 || "",
        address2: contract.userData.Address2 || "",
        zipCode: contract.userData.ZipCode || "",
        language: languageValue,
        raceEthnicity: contract.userData.Country === "Canada" ? "" : ethnicityValue,
        preferredName: contract.userData.PreferredName || "",
        gender: contract.userData.Gender || "",
        relationshipStatus: contract.userData.RelationshipStatus || "",
        pronouns: contract.userData.Pronouns || "",
        goal: contract.userData.Goal || ""
      });
    }
  }, [contract.userData]);

  const getFormErrors = (data) => {
    const formErrors = {};

    if (!data.phoneNumber.trim()) formErrors.phoneNumber = t('phonenumberrequired');
    if (!data.state.trim()) formErrors.state = "State is required";
    if (!data.city.trim()) formErrors.city = "City is required";
    if (!data.zipCode.trim()) formErrors.zipCode = "Zip code is required";
    if (!data.address1.trim() && !data.address2.trim()) {
      formErrors.address1 = "At least one address is required";
    }

    return formErrors;
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let updatedFormData;

    if (id === "phoneNumber") {
      // Only allow digits
      const numericValue = value.replace(/\D/g, "");
      updatedFormData = {
        ...formData,
        [id]: numericValue,
      };
    } else {
      updatedFormData = {
        ...formData,
        [id]: value,
      };

      // Clear ethnicity when Canada is selected
      if (id === "country" && value === "Canada") {
        updatedFormData.raceEthnicity = "";
      }
    }

    setFormData(updatedFormData);

    const nextErrors = getFormErrors(updatedFormData);
    setErrors((prev) => ({
      ...prev,
      state: nextErrors.state || "",
      city: nextErrors.city || "",
      address1: nextErrors.address1 || "",
      zipCode: nextErrors.zipCode || "",
      phoneNumber: nextErrors.phoneNumber || "",
      ...(id === "country" ? { country: nextErrors.country || "" } : {}),
    }));
  };

  const isValidForm = () => {
    const formErrors = getFormErrors(formData);
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const hasValidationErrors = Object.values(errors).some(Boolean);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double submit
    setIsSubmitting(true);
    if (!isValidForm()) {
      setIsSubmitting(false);
      return;
    }

    const updatedData = {
      FirstName: contract.userData.FirstName || "",
      LastName: contract.userData.LastName || "",
      PreferredName: contract.userData.PreferredName,
      EmailID: contract.userData.EmailID || "",
      PWD: contract.userData.PWD || "",
      ConfirmPassword: contract.userData.ConfirmPassword || "",
      AgreeTerms: contract.userData.AgreeTerms || false,
      Country: formData.country,
      Language: formData.language,
      Ethnicity: formData.country === "Canada" ? "" : formData.raceEthnicity || "",
      PhoneNo: formData.phoneNumber || "",
      DOB: contract.userData.DOB || "",
      State: formData.state,
      City: formData.city,
      Address1: formData.address1,
      Address2: formData.address2,
      ZipCode: formData.zipCode,
      TextNotificationStatus: contract.userData.TextNotificationStatus || "No",
      Version: "10.8",
      AppLanguage: contract.userData.AppLanguage || "English",
      DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      Company: contract.userData.Company || "",
      MemberID: contract.userData.MemberID || "",
      WhyHere: contract.userData.WhyHere || "",
      WINBenefits: "Y",
      Promocode: contract.userData.EmployerCode,
      Pronouns: contract.userData.Pronouns,
      UpdateFlag: "Y",
      JourneyStatus: contract.userData.JourneyStatus || "",
      HealthPlanId: contract.userData.HealthPlanId || "",
      RelationshipStatus: contract.userData.RelationshipStatus,
      IsHealthProfileCompleted: 1,
      BenefitProvider: contract.userData.BenefitProvider,
      SubscriberID: contract.userData.SubscriberID || "",
      Gender: contract.userData.Gender,
      Contract: contract.userData.ContractIdentified || contract.userData.Contract,
      SecureCode: contract.userData.SecureCode,
      Goal: contract.userData.Goal,
      CountryCode: contract.userData.CountryCode,

    };
console.log("Updated Data Payload:", updatedData); // Debug log to check the payload
    try {
      const response = await axios.post(
        Endpoints.CreateAccount,
        `_Params=${encodeURIComponent(JSON.stringify(updatedData))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            // "Authorization": `Bearer ${token}`,
          }
        }
      );
      if (response.data.Result === 2) {
        // Dispatch the action to update user data in the Redux store
        debugger
        dispatch(updateUserData(response.data));
        toast.success(t('addressupdate'));
        window.dispatchEvent(new Event("resetHeaderMenu"));

        setTimeout(() => {
          navigate("/home");
        }, 2000);
        return;
      }

      if (response.data.Result === 0) {
        navigate("/registration-error");
        return;
      }

      toast.error(response.data.Message || t('updatefailed'));
    } catch (error) {
      console.error("API Error:", error);
      toast.error(t('erroroccuredupdatephonenumber'));
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
const capitalizeFirstLetter = (name) => {
  if (!name) return ''; // If no name is provided, return an empty string
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(); // Capitalize first letter and lowercase the rest
};

console.log("Form Data:", formData);

  return (
    <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-secondary-black">{t('nicetomeetyou')}</h3>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="country" className="form-label win-form-label mandatory">{t('selectcouontry')}</label>
                  <CustomDropdown
                  options={countries.map(c => c.label)} 
                  selectedOption={isHighmarkPortal
                  ? "United States of America" : formData.country || ""}
                  onChange={(label) => {
                    setFormData(prev => ({
                      ...prev,
                      country: label,
                      raceEthnicity: label === "Canada" ? "" : prev.raceEthnicity,
                    }));
                    setErrors(prev => ({
                      ...prev,
                      country: "",
                    }));
                  }}
                  placeholder={t('selectcountry')}
                  disabled={isHighmarkPortal}
                  searchable={true}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="state" className="form-label win-form-label mandatory">{t('state')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="state"
                  value={formData.state}
                  onChange={handleInputChange}
                />
                {errors.state && <div className="form-field-error-message">{errors.state}</div>}
              </div> 

              <div className="mb-3">
                <label htmlFor="city" className="form-label win-form-label mandatory">{t('city1')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
                {errors.city && <div className="form-field-error-message">{errors.city}</div>}
              </div>

              <div className="mb-3">
                <label htmlFor="address1" className="form-label win-form-label mandatory">{t('address1')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="address1"
                  value={formData.address1}
                  onChange={handleInputChange}
                />
                {errors.address1 && <div className="form-field-error-message">{errors.address1}</div>}
              </div>

              <div className="mb-3">
                <label htmlFor="address2" className="form-label win-form-label">{t('address2')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="address2"
                  value={formData.address2}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="zipCode" className="form-label win-form-label mandatory">{t('zipcode')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="zipCode"
                  value={formData.zipCode}
                  onChange={handleInputChange}
                />
                {errors.zipCode && <div className="form-field-error-message">{errors.zipCode}</div>}
              </div>

              <div className="mb-3 mt-4">
                <button
                  className="win-btn-primary mobile-view"
                  type="submit"
                  disabled={isSubmitting || hasValidationErrors}
                >
                  {t('Submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default UpdateAddress;
